/** Selo de status. A cor segue o texto, como no `chip()` do mock. */
export function chipTone(s: string): "green" | "amber" | "red" | "orange" {
  if (/Resolvida|Aprovado|Ativo|Concordo|OK|Conectado/.test(s)) return "green";
  if (/revisão|Pendente|análise|Atenção|Convite/.test(s)) return "amber";
  if (/Rejeitado|Crítico|Discordo|Removido|Desativado/.test(s)) return "red";
  return "orange";
}

export function Chip({ children }: { children: string }) {
  return <span className={`badge ${chipTone(children)}`}>{children}</span>;
}
